export default __webpack_public_path__ + "static/media/WP.59016040.mp4";